









































import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
import { ElMenu } from 'element-ui/types/menu'
const AppModule = namespace('app')
const UserModule = namespace('user')

@Component({
  components: {}
})
export default class Menubar extends Vue {
  public name = 'Menubar'
  public loading = false

  public $refs!: {
    refMenus: ElMenu
  }

  @AppModule.Action('ToggleSideBar')
  public actionToggleSideBar!: () => void
  @AppModule.Getter
  public sidebar!: { opened: boolean, withoutAnimation: boolean }

  @UserModule.Getter('userInfo')
  public curUser!: UserData

  @UserModule.Getter('menus')
  public menus!: any[]

  @UserModule.Action('SetMenu')
  public setMenu!: () => Promise<{}>
  @UserModule.Action('SetUserAuth')
  public setUserAuth!: () => Promise<{}>

  public openedIndex: any = ''
  //index: 打开的 sub-menu 的 index， indexPath: 
  public menuOpen(index: any, indexPath: any) {
    this.openedIndex = index
    // console.log('open', index, indexPath)
  }
  public menuClose(index: any, indexPath: any) {
    // console.log('close', index, indexPath)
    this.openedIndex = ''
  }
  public subMenuClick() {
    if (this.openedIndex != '') {
      this.$refs.refMenus.close(this.openedIndex)
      this.openedIndex = ''
    }
  }

  public created() {
    this.setMenu()
    this.setUserAuth()
  }

  public toggleSideBar() {
    this.actionToggleSideBar()
  }
  public getActiveClass(menuPath: string) {
    // console.log('getActiveClass', menuPath, this.$route.path)
    if (this.$route.path == menuPath || this.$route.path.indexOf(menuPath + '/') > -1) {
      return 'is-active'
    }
    return ''
  }
  @Watch('$route')
  public onRouteChange(route: any) {
    if (this.$route.path == '/') {
      // console.log('点击首页，把展开的菜单收起来')
      if (this.openedIndex != '') {
        this.$refs.refMenus.close(this.openedIndex)
        this.openedIndex = ''
      }
    }
  }
}
